 
document.addEventListener("DOMContentLoaded", function () {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const items = cart.items;

      const freeItems = items.filter(
        (item) =>
          item.final_line_price === 0 ||
          item.title.toLowerCase().includes("free")
      );

      const paidItems = items.filter((item) => item.final_line_price > 0);

      // ✅ Ensure free gift quantity is 1
      let qtyAdjusted = false;
      freeItems.forEach((item) => {
        if (item.quantity > 1) {
          updateFreeItemQtyToOne(item.key);
          qtyAdjusted = true;
        }
      });

      if (qtyAdjusted) return; // Exit early so page reloads after quantity fix

      // ✅ Allow only one free item – keep the most recent one (first in the array)
      if (freeItems.length > 1) {
        const latestFreeItem = freeItems[0]; // First = latest
        const toRemove = freeItems.slice(1); // Remove others
        toRemove.forEach((item) => removeCartItem(item.key));
        return;
      }

      // ❌ No free gift without paid item
      if (freeItems.length > 0 && paidItems.length === 0) {
        alert("To get the free gift, please keep at least one paid product in the cart.");
        freeItems.forEach((item) => removeCartItem(item.key));
        return;
      }

      // ✅ Enable controls for paid items if multiple
      if (paidItems.length > 1) {
        enableAllControls();
      }

      // ❌ Disable quantity & remove for free item
      freeItems.forEach((item) => {
        disableControls(item.key);
      });
    });

  function removeCartItem(lineItemKey) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
    }).then(() => location.reload());
  }

  function updateFreeItemQtyToOne(lineItemKey) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineItemKey, quantity: 1 }),
    }).then(() => location.reload());
  }

  function disableControls(lineKey) {
    // Disable quantity input
    $('input[data-line-key="' + lineKey + '"]').prop('disabled', true);

    // Disable + and - buttons
    $('a.quantity-selector__button[href*="' + lineKey + '"]')
      .on('click', function (e) {
        e.preventDefault();
      })
      .css({
        'pointer-events': 'none',
        'opacity': '0.5'
      });

    // Disable remove link
    $('a.link.text-xs[href*="' + lineKey + '"][href*="quantity=0"]')
      .on('click', function (e) {
        e.preventDefault();
      })
      .css({
        'pointer-events': 'none',
        'opacity': '0.5'
      });
  }

  function enableAllControls() {
    document.querySelectorAll("input[data-line-key]").forEach((input) => {
      input.removeAttribute("disabled");

      const parent = input.closest(".quantity-selector");
      if (parent) {
        parent.querySelectorAll("a").forEach((btn) => {
          btn.removeAttribute("style");
        });
      }

      const row = input.closest("tr");
      if (row) {
        const removeLink = row.querySelector("a.link.text-xs[href*='quantity=0']");
        if (removeLink) {
          removeLink.removeAttribute("style");
        }
      }
    });
  }
}); 


 